import { DataManager, UrlAdaptor } from '@syncfusion/ej2-data';
import { ComboBox } from '@syncfusion/ej2-dropdowns';

import pluralize from 'pluralize';

import { routes } from '@/shared/routes';
import { ModelName, ViewModels } from '@/shared/types/model';

const lookupPickers: Record<string, ComboBox> = {};

document.addEventListener('DOMContentLoaded', () => {
  [...document.querySelectorAll('.lookup-picker')]
    .map((element) => element as HTMLInputElement)
    .forEach((input) => {
      const model = input.dataset.model as ModelName | undefined;

      const { placeholder, width } = input.dataset;

      if (model) {
        const lookupPicker = new ComboBox({
          dataSource: new DataManager({
            url: routes.data.lookup.list({ model }),
            adaptor: new UrlAdaptor(),
          }),
          fields: {
            value: 'value',
            text: 'text',
          },
          placeholder: placeholder ?? `Search ${pluralize(ViewModels[model] ?? model)}`,
          sortOrder: 'Ascending',
          value: input.dataset.value ?? undefined,
          allowCustom: false,
          allowFiltering: true,
          width,
        });

        lookupPicker.appendTo(input);

        if (input.id) {
          lookupPickers[input.id] = lookupPicker;
        }
      }
    });
});

export const getLookupPicker = (id: string): ComboBox | undefined => lookupPickers[id];
